import { fetcher } from '@commenda/utils';
import {
  Country,
  MarketplaceProductBillingInterval,
  MarketplaceServiceProviderType,
  MarketplaceServiceType,
} from '@prisma/client';

const BASE_URL = 'marketplace/product';

interface IPricingVariant {
  country: Country;
  internalMargin: number;
}

export interface ICreateOrUpdateEditMarketplaceServicePayload {
  id?: string;
  title: string;
  description: string;
  category: MarketplaceServiceType;
  providedByTypes: MarketplaceServiceProviderType[];
  billingInterval?: MarketplaceProductBillingInterval;
  pricingVariants?: IPricingVariant[];
  isExperimental?: boolean;
}

type CreateEditMarketplaceServiceProps = {
  data: ICreateOrUpdateEditMarketplaceServicePayload;
};

export async function createOrUpdateMarketplaceService({
  data,
}: CreateEditMarketplaceServiceProps) {
  try {
    const { id, ...payload } = data;
    const res = await fetcher(
      id ? `${BASE_URL}/${id}` : BASE_URL,
      {
        method: 'POST',
        body: payload,
      },
      undefined
    );

    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
}
